import {useContext} from 'react';
import {StoreContext} from '@roc/feature-app-core';
import { ReferralsStore } from '@roc/feature-referrals';

export const useReferralsStore = () => useContext<ReferralsStore>(StoreContext)
